<template>
  <div class="mode-switch">
    <h1>{{ $t(confirmKeys.label) }}</h1>
    <div class="description">
      <p v-html="$t(confirmKeys.description)"></p>
    </div>
    <ProductSettingsModeComparison />
    <div class="actions">
      <button class="btn btn-primary" @click="modalInstance.close">
        {{ $t(confirmKeys.label) }}
      </button>
      <button class="btn btn-ghost" @click="modalInstance.dismiss">
        {{ $t('GENERAL.CANCEL') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CompositionMode } from '@spreadgroup/common-partner-lib/composition';
import { computed } from 'vue';
import ProductSettingsModeComparison from 'src/app/partnerarea/publishing/detail/productSettings/ProductSettingsModeComparison.vue';

const props = defineProps<{
  modalInstance: {
    close: () => void;
    dismiss: () => void;
  };
  data: {
    targetMode: CompositionMode;
  };
}>();

const confirmKeys = computed(() => {
  const isToSmart = props.data.targetMode === CompositionMode.SMART;
  return {
    label: isToSmart
      ? 'PUBLISHING.DETAIL.PRODUCTS.MODES.SWITCH_CONFIRM.TO_SMART'
      : 'PUBLISHING.DETAIL.PRODUCTS.MODES.SWITCH_CONFIRM.TO_ADVANCED',
    description: isToSmart
      ? 'PUBLISHING.DETAIL.PRODUCTS.MODES.SWITCH_CONFIRM.DESCRIPTION_ADVANCED_TO_SMART'
      : 'PUBLISHING.DETAIL.PRODUCTS.MODES.SWITCH_CONFIRM.DESCRIPTION_SMART_TO_ADVANCED',
  };
});
</script>

<style scoped lang="scss">
@import 'src/scss/constants';
@import 'src/scss/styleguide/colors';

.mode-switch {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

h1,
p {
  margin: 0;
}

.description {
  max-width: 600px;
}

.actions {
  display: flex;
  gap: 16px;
}
</style>
